import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            padding: theme.spacing(3),
        },
        header: {
            marginBottom: theme.spacing(3),
        },
        moduleFilter: {
            marginBottom: theme.spacing(3),
            display: 'flex',
            gap: theme.spacing(2),
            alignItems: 'center',
        },
        processList: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
        },
        processCard: {
            cursor: 'pointer',
            transition: 'box-shadow 0.2s',
            '&:hover': {
                boxShadow: theme.shadows[4],
            },
        },
        processCardSelected: {
            borderLeft: `4px solid ${theme.palette.primary.main}`,
        },
        sectionTitle: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(1),
            fontWeight: 600,
        },
        sectionContent: {
            padding: theme.spacing(2),
            backgroundColor: '#f8f9fb',
            borderRadius: 4,
            marginBottom: theme.spacing(2),
        },
        stepList: {
            listStyle: 'none',
            padding: 0,
            margin: 0,
        },
        stepItem: {
            padding: theme.spacing(0.5, 0),
            borderBottom: '1px solid #e6e6e6',
            '&:last-child': {
                borderBottom: 'none',
            },
        },
        chip: {
            margin: theme.spacing(0.5),
        },
        fieldTable: {
            width: '100%',
            borderCollapse: 'collapse',
            '& th, & td': {
                border: '1px solid #e6e6e6',
                padding: theme.spacing(1),
                textAlign: 'left',
                fontSize: 13,
            },
            '& th': {
                backgroundColor: '#f5f5f5',
                fontWeight: 600,
            },
        },
        integrationCard: {
            padding: theme.spacing(1.5),
            marginBottom: theme.spacing(1),
            border: '1px solid #e6e6e6',
            borderRadius: 4,
        },
        plantSection: {
            marginTop: theme.spacing(1),
            padding: theme.spacing(2),
            border: '1px solid #e0e0e0',
            borderRadius: 4,
            marginBottom: theme.spacing(1),
        },
        plantName: {
            fontWeight: 600,
            color: theme.palette.primary.main,
            marginBottom: theme.spacing(1),
        },
        backButton: {
            marginBottom: theme.spacing(2),
        },
        moduleChip: {
            marginRight: theme.spacing(1),
            fontWeight: 500,
        },
        noPermission: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: 'calc(100vh - 200px)',
        },
    })
);
